import React, { FC, memo } from 'react';
import ProductGridTile from '@/components/organisms/product-list/components/product-tile/product-grid';
import ProductListTile from '@/components/organisms/product-list/components/product-tile/product-list';

interface ProductTileProps {
  product: any;
  onClick?: () => void;
  isSearchResult?: boolean;
  isCollectionPage?: boolean;
  isCategoryPage?: boolean;
  disableQuickView?: boolean;
  disableWishlistButton?: boolean;
  isBimLibraryPage?: any;
  disableVariants?: boolean;
  images?: string[];
  selectedVariantIndex?: number;
  onAddToProject?: (variant: any) => void;
  handleSelectProduct?: (product: any) => void;
  getIsCheckedProduct?: (product: any) => boolean;
  viewMode: string | undefined;
  showForInfoMsg?:boolean
}

const ProductTile: FC<ProductTileProps> = ({
  product,
  onAddToProject,
  viewMode,
}) => {
  // const isBuilderRange = product?.attributesAlgolia?.['builder-range']?.['en-AU']?.toUpperCase() === 'YES';
  // const isLoggedInInternalUser = false;

  // const hidePriceAndProjAccess = isTohidePriceData({
  //   locale, isBuilderRange,
  //   isLoggedInInternalUser, isLoggedInInternalUser
  // });

const handleOnAddToProject = ()=>{
  if(onAddToProject){
    onAddToProject(product?.variants[0])
  }
}
  return (
    <>
      {viewMode == 'list' ? (
        <>
         <ProductListTile item={product} onAddToProject={handleOnAddToProject} parent="project-builder"/>
        </>
      ) : (
        <ProductGridTile item={product} onAddToProject={handleOnAddToProject} parent="project-builder"/>
      )}
    </>
  );
};

export default memo(ProductTile);
